
import { Component, OnInit, ViewEncapsulation, Input } from '@angular/core';
import { MatDialog } from '@angular/material';
import { Router, ActivatedRoute } from '@angular/router';
import { QueryInterface } from 'app/shared/common/parse/query-interface';
import { ParseService } from 'app/shared/common/parse/parse.service';
import { Location } from '@angular/common';
import { SelectItem } from '../../../../employees/employees.component';
import { LazyLoadEvent } from 'primeng/primeng';
import moment from 'moment';
import { StorageConfiguration } from 'app/shared/common/storage-setting/storage-configuration';
import { NgxSpinnerService } from 'ngx-spinner';
import { ToastrService } from 'ngx-toastr';

@Component({
  selector: 'app-add-ons-list',
  templateUrl: './add-ons-list.component.html',
  styleUrls: ['./add-ons-list.component.scss'],
  encapsulation: ViewEncapsulation.None
})

export class AddOnsListComponent implements OnInit {

  @Input() projectId: any;
  clientNameDD = [];
  clientNameOptions: SelectItem[];
  projectTypeOptions: SelectItem[];
  totalRecords: number;
  loading: boolean;
  loadEventData: LazyLoadEvent;
  selectProjectType: String[];
  selectClientName: String[];
  cols: any[];
  projectList = [];
  projectGrid = [];
  public paginationNumberFormatter;
  value: any;
  userId = this.parseService.instance.User.current().id;
  empRole = '';
  objectId = '';
  projectStatusOptions: SelectItem[];
  // objectId = '';
  public paginationPageSize;
  private gridApi;
  private gridColumnApi;
  showFilter: any;
  gridView: boolean;
  todayDate = new Date();
  projectMems = [];
  parentProjectId: any;
  totalhours: any;
  addOnProjectId = [];
  today = new Date().toISOString();
  selectProjectStatus: String[];

  constructor(
    private route: ActivatedRoute,
    public dialog: MatDialog,
    private router: Router,
    private queryInterface: QueryInterface,
    private _location: Location,
    private parseService: ParseService,
    private storageConfiguration: StorageConfiguration,
    private spinner: NgxSpinnerService,
    private toastr: ToastrService,

  ) {
    this.paginationPageSize = 10;
    this.paginationNumberFormatter = function (params) {
      return '' + params.value.toLocaleString() + '';
    };
    this.projectTypeOptions = [
      { label: 'Dedicated', value: 'Dedicated' },
      { label: 'Fixed', value: 'Fixed' }
    ];

    this.cols = [
      { header: 'S.No', field: 'position' },
      { field: 'action', header: 'Action' },
      { header: 'Project Name', field: 'projectName' },
      { header: 'Platform', field: 'projectPlatform' },
      { header: 'Start Date', field: 'projectStartDate' },
      { header: 'Due Date', field: 'projectEndDate' },
      { header: 'Client Name', field: 'clientName' },
      { header: 'Billing Type', field: 'projectType' },
      { header: 'Project Status', field: 'currentStatus' }
    ];
    this.empRole = this.storageConfiguration.sessionGetItem(this.storageConfiguration.role);

    this.projectStatusOptions = [
      { label: 'New', value: 'New' },
      { label: 'In Progress', value: 'In Progress' },
      { label: 'On Hold', value: 'On Hold' },
      { label: 'Completed', value: 'Completed' },
      { label: 'Rejected', value: 'Rejected' },
      // { label: 'Archived', value: 'Archived' }
    ];
  }

  ngOnInit() {

    this.route.params.subscribe(params => {
      let parentProjectId = params['id'];
      this.objectId = params['id'];

      if (parentProjectId) {
        this.parentProjectId = parentProjectId;
      }
    });
    this.getAddOnProjectList();
    // this.getAddOnProject();
    this.getClientName();
    this.gridView = false;
    // this.getProMembers();

    let filter = JSON.parse(localStorage.getItem('addOnsTable'));

    if (filter != null && filter.filters != undefined) {
      if (filter.filters['projectInfo.projectType'] != undefined) {
        this.selectProjectType = filter.filters['projectInfo.projectType'].value;
      }
      if (filter.filters[this.empRole != 'Admin' ? 'currentStatus' : 'projectInfo.currentStatus'] != undefined) {
        this.selectProjectStatus = filter.filters[this.empRole != 'Admin' ? 'currentStatus' : 'projectInfo.currentStatus'].value;
      }

      if (filter.filters['client'] != undefined) {
        this.selectClientName = filter.filters['client'].value;
      }
    }
  }

  /*
  ** ==========================================================
  ** Get add ons project details
  ** ==========================================================
  */
  getAddOnProject() {

    this.queryInterface.executeQuery(this.parseService, 'Project', [
      { condition: 'equalTo', field: 'objectId', value: this.projectId }]).then(project => {
        project.forEach(element => {
          this.addOnProjectId = [];
          this.getRelation(element).then(addOns => {
            addOns.forEach(element => {
              this.addOnProjectId.push(element.id);
            });
            this.gridView = false;
          });
        });
        let event: LazyLoadEvent = {};
        event.filters = {};
        event.first = 0;
        event.rows = 10;
        event.sortOrder = 1;
        event.sortField = undefined;
        this.onLazyLoad(event);
      });
  }

  onPageSizeChanged() {
    var value = (<HTMLInputElement>document.getElementById('page-size')).value;
    this.gridApi.paginationSetPageSize(Number(value));
  }
  projectCreate() {
    this.router.navigate(['add-ons'], { queryParams: { ProjectId: this.objectId, mode: 'add' } });
  }

  async getAddOnProjectList() {
    this.spinner.show();
    let projectMembersInstance = this.parseService.instance.Object.extend('ProjectMembers');
    let projectMemberQuery = new this.parseService.instance.Query(projectMembersInstance);
    projectMemberQuery.include('user');
    projectMemberQuery.include('user.profile');
    projectMemberQuery.limit(5000);

    let projectInstance = this.parseService.instance.Object.extend('Project');
    let projectQuery = new this.parseService.instance.Query(projectInstance);
    projectQuery.equalTo('objectId', this.projectId);
    await Promise.all([projectMemberQuery.find(), projectQuery.find()]).then((projects) => {

      projects[1].forEach(async element => {
        this.addOnProjectId = [];
        await this.getRelation(element).then(addOns => {
          addOns.forEach(innerElement => {
            this.addOnProjectId.push(innerElement.id);
          });
          this.gridView = false;
        });
        this.projectMems = projects[0];
        this.getProjects();
      });

    });
    this.spinner.hide();
  }


  /*
  ** ==========================================================
  ** Get project members
  ** ==========================================================
  */
  getProMembers() {
    let queryInstance = this.parseService.instance.Object.extend('ProjectMembers');
    let query = new this.parseService.instance.Query(queryInstance);
    query.include('user');
    query.include('user.profile');
    query.limit(5000);
    query.find().then(result => {
      this.projectMems = result;
      this.getProjects();
    });
  }

  backlocation() {
    this._location.back();
  }

  bindClientDropDown(array: any[]): any[] {
    const dropDownItem = [];
    array.forEach(a => {
      // dropDownItem.push({ label: a.name, value: a.id });
      dropDownItem.push({ label: a.name, value: a.name });
    });
    return dropDownItem;
  }

  async getClientName() {
    let result = [];
    this.queryInterface.executeQuery(this.parseService, 'Client', [{ field: 'name', condition: 'descending' }]).then(results => {
      for (let i = 0; i < results.length; i++) {
        let jsonText = JSON.stringify(results[i]);
        let clientNameInfo = JSON.parse(jsonText);
        result.push({ name: clientNameInfo.companyInfo.firstName.concat(' ' + clientNameInfo.companyInfo.lastName), id: clientNameInfo.objectId });
      }
      this.clientNameDD = result;
      this.clientNameDD = this.clientNameDD.sort((a, b) => a.name.localeCompare(b.name));
      this.clientNameOptions = this.bindClientDropDown(this.clientNameDD);
    });
  }

  /*
  ** ==========================================================
  ** Get add ons list
  ** ==========================================================
  */
  async getProjects() {
    if (this.empRole == 'Employee') {
      // this.totalRecords = await this.getCount();
      this.queryInterface.executeQuery(this.parseService, 'ProjectMembers',
        [
          { condition: 'include', value: 'project' },
          { condition: 'include', value: 'project.client' },
          { condition: 'include', value: 'user' },
          { condition: 'ascending', value: 'companyName' },
          { condition: 'equalTo', field: 'status', value: 'Assigned' },
          {
            condition: 'equalTo', field: 'user', value: {
              __type: 'Pointer',
              className: '_User',
              objectId: this.userId
            }
          },
          { condition: 'containedIn', field: 'project', value: this.addOnProjectId }
        ]
      ).then(results => {
        let projects = [];
        results.forEach(element => {
          projects.push(element.get('project'));
        });
        this.projectGrid = this.loadResourcesEmployee(projects, 0);
        this.projectList = this.projectGrid;
      });
    }

    else if (this.empRole != 'Employee') {
      // this.totalRecords = await this.getCount();
      this.queryInterface.executeQuery(this.parseService, 'Project',
        [
          { condition: 'containedIn', field: 'objectId', value: this.addOnProjectId },
          { condition: 'include', value: 'client' },
          { condition: 'descending', field: 'updatedAt' },
          { condition: 'equalTo', field: 'isActive', value: true }
          // { condition: 'limit', value: 100 }
        ]).then(results => {
          this.projectGrid = this.loadResourcesAdmin(results, 0);
          this.projectList = this.projectGrid;
          this.clientNameDD = this.clientNameDD.sort((a, b) => a.name.localeCompare(b.name));
          this.clientNameOptions = this.bindClientDropDown(this.clientNameDD);
        });
    }
  }

  /*
  ** ==========================================================
  ** Add ons details
  ** ==========================================================
  */
  loadResourcesEmployee(results, skip) {
    let result = [];
    let i = skip;

    results.forEach(element => {
      i = i + 1;
      let total = element.get('resourceDetails').details;
      // total.forEach(element => {
      //   totalResource = element.count;
      // });
      let totalhours = this.getHoursCount(total);

      let totalResource = this.getResourceCount(total);

      // let project = element.get('project');
      let projectdetail = element.get('projectInfo');
      let client = element.get('client');
      let clientdetail = client.get('companyInfo');

      let progress = this.getProgressPercent(
        projectdetail.projectStartDate,
        projectdetail.actualCompletionDate
      );

      result.push({
        position: i,
        projectName: projectdetail.projectName,
        currentStatus: projectdetail.currentStatus,
        projectStartDate: projectdetail.projectStartDate,
        projectEndDate: projectdetail.actualCompletionDate,
        clientName: clientdetail.firstName.concat(' ' + clientdetail.lastName),
        projectType: projectdetail.projectType,
        projectPlatform: projectdetail.projectPlatform,
        progress: progress,
        totalhours: totalhours,
        totalcount: totalResource,
        objectId: element.id,
        projectMembers: this.getProjectMembersName(element)
      });
    });
    return result;
  }

  getResourceCount(totalcount) {
    let total = 0;
    totalcount.forEach(element => {
      total += element.count;
    });

    return total;
  }

  getDifference(startDate, endDate) {
    const daydiff = moment(startDate).diff(moment(endDate), 'days');
    return Math.abs(daydiff);
  }

  getProgressPercent(start, end) {
    if (new Date() > new Date(start)) {
      let totalDiff = this.getDifference(start, end);
      let currentDiff = this.getDifference(start, new Date());
      return (currentDiff / totalDiff) * 100;
    } else {
      return 0;
    }
  }

  getProjectMembers(project) {
    let proMembers = [];
    let memName = [];
    proMembers = this.projectMems.filter(s => s.get('project').id == project.id);

    proMembers.forEach(element => {
      let fName = element.get('user').get('profile').get('firstName');
      let lName = element.get('user').get('profile').get('lastName');
      let name = fName + ' ' + lName;
      let shortName = fName.charAt(0).toUpperCase() + lName.charAt(0).toUpperCase();
      memName.push({ name: name, shortName: shortName });
    });
    return memName;
  }

  getProjectMembersName(project) {
    let proMembers = [];
    let proMembersAssigned = [];
    let profileImageInfo = [];
    proMembers = this.projectMems.filter(s => s.get('project').id == project.id);

    proMembersAssigned = proMembers.filter(a => a.get('status') == 'Assigned');
    proMembersAssigned.forEach(res => {
      let profilePic = res.get('user').get('profile').get('profileImageInfo').url;

      let fName = res.get('user').get('profile').get('firstName');
      let lName = res.get('user').get('profile').get('lastName');
      let name = fName + ' ' + lName;
      let shortName = fName.charAt(0).toUpperCase() + lName.charAt(0).toUpperCase();

      profileImageInfo.push({ name: name, shortName: shortName, profilePic: profilePic });
    });
    return profileImageInfo
  }

  loadResourcesAdmin(results, skip) {

    let result = [];
    let i = skip;
    results.forEach(element => {
      i = i + 1;
      let total = element.get('resourceDetails').details;
      // total.forEach(element => {
      //   totalResource = element.count;
      // });
      let totalhours = this.getHoursCount(total);

      let totalResource = this.getResourceCount(total);

      let projectdetail = element.get('projectInfo');
      let client = element.get('client');
      let clientdetail = client.get('companyInfo');
      let progress = this.getProgressPercent(
        projectdetail.projectStartDate,
        projectdetail.actualCompletionDate
      );
      result.push({
        position: i,
        projectName: projectdetail.projectName,
        currentStatus: projectdetail.currentStatus,
        projectStartDate: projectdetail.projectStartDate,
        projectEndDate: projectdetail.actualCompletionDate,
        clientName: clientdetail.firstName.concat(' ' + clientdetail.lastName),
        projectType: projectdetail.projectType,
        projectPlatform: projectdetail.projectPlatform,
        progress: progress,
        objectId: element.id,
        totalhours: totalhours,
        totalcount: totalResource,
        projectMembers: this.getProjectMembersName(element)
      });
    });

    return result;
  }

  getHoursCount(totalhours) {
    let total = 0;
    totalhours.forEach(element => {
      total += element.hours;
    });
    return total;
  }

  async getRelation(result) {
    var reportingList = []
    await result
      .relation('addOn')
      .query()
      .each(function (obj) {
        reportingList.push(obj);
      });
    return reportingList;
  }

  /*
  ** ==========================================================
  ** Lazy load
  ** ==========================================================
  */
  async onLazyLoad(event: LazyLoadEvent) {

    this.loadEventData = event;
    let condition = [];
    let type = '';
    if (this.empRole == 'Employee') {
      condition = [
        // { condition: 'include', value: 'client' },
        { condition: 'include', value: 'project' },
        { condition: 'include', value: 'project.client' },
        { condition: 'include', value: 'user' },
        { condition: 'ascending', value: 'companyName' },
        {
          condition: 'equalTo', field: 'user', value: {
            __type: 'Pointer',
            className: '_User',
            objectId: this.userId
          }
        },
        { condition: 'containedIn', field: 'project', value: this.addOnProjectId }
      ];
      type = 'ProjectMembers';
    } else {
      condition = [
        // { field: 'objectId', condition: 'descending' },
        { condition: 'include', value: 'client' },
        { condition: 'containedIn', field: 'objectId', value: this.addOnProjectId },
        { condition: 'descending', field: 'updatedAt' },
        { condition: 'equalTo', field: 'isActive', value: true }
      ];
      type = 'Project';
    }

    const filter: any = event.filters;
    if (!filter) {
      const skip: number = event.first;
      this.totalRecords = await this.getTotalRecordsCount(condition, type);
      this.lazyLoad(condition, skip, type, event.rows);
    } else if (event.sortField) {
      const skip: number = event.first;

      let field = event.sortField;
      let sortOrder = event.sortOrder == 1 ? 'descending' : 'ascending';
      // tslint:disable-next-line:forin
      for (let key in filter) {
        let query = filter[key].value;
        if (key == 'projectInfo.projectType' || key == 'client' || key == 'projectInfo.currentStatus') {
          condition.push({
            condition: 'containedIn',
            field: key,
            value: filter[key].value
          });
        } else {
          let filterValue;
          filterValue = filter[key].value.replace(/\b\w/g, l =>
            l.toUpperCase()
          );
          condition.push({
            condition: 'contains',
            field: key,
            value: filterValue
          });
        }
      }
      if (sortOrder == 'ascending') {
        condition.push({ condition: sortOrder, value: field });
      } else {
        condition.push({ condition: sortOrder, field: field });
      }

      this.totalRecords = await this.getTotalRecordsCount(condition, type);
      if (this.totalRecords < event.first) {
        event.first = 0;
      }
      this.lazyLoad(condition, skip, type, event.rows);
    } else {
      // tslint:disable-next-line:forin
      for (let key in filter) {
        let query = filter[key].value;
        if (key == 'projectInfo.projectType' || key == 'client' || key == 'projectInfo.currentStatus') {
          condition.push({
            condition: 'containedIn',
            field: key,
            value: filter[key].value
          });
        } else {
          let filterValue;
          filterValue = filter[key].value.replace(/\b\w/g, l =>
            l.toUpperCase()
          );
          condition.push({
            condition: 'contains',
            field: key,
            value: filterValue
          });
        }
      }
      this.totalRecords = await this.getTotalRecordsCount(condition, type);
      if (this.totalRecords < event.first) {
        event.first = 0;
      }
      this.lazyLoad(condition, event.first, type, event.rows);
    }
  }

  lazyLoad(condition, skip, type, limit) {
    condition.push(
      { condition: 'skip', value: skip },
      { condition: 'limit', value: limit }
    );
    this.queryInterface.executeQuery(this.parseService, type, condition).then(results => {
      if (this.empRole != 'Employee') {
        this.projectList = this.loadResourcesAdmin(results, skip);
      } else {
        let projects = [];
        results.forEach(element => {
          projects.push(element.get('project'));
        });
        this.projectList = this.loadResourcesEmployee(projects, skip);
      }
    });
  }

  getTotalRecordsCount(condition, type) {
    return this.getQueryCount(this.parseService, type, condition);
  }

  /*
  ** ==========================================================
  ** Get total records
  ** ==========================================================
  */
  getCount() {
    let id = '';
    let condition = [];
    let type = '';
    if (this.empRole != 'Admin') {
      id = this.userId;
      type = 'ProjectMembers';
      condition.push(
        { field: 'objectId' },
        {
          condition: 'equalTo',
          field: 'user',
          value: {
            __type: 'Pointer',
            className: '_User',
            objectId: id
          }
        },
        { condition: 'include', value: 'client' },
        { condition: 'include', value: 'project' },
        { condition: 'include', value: 'project.client' },
        { condition: 'include', value: 'user' }
      );
    } else if (this.empRole == 'Admin') {
      type = 'Project';
      condition.push(
        // { field: 'objectId', condition: 'descending' },
        { condition: 'descending', field: 'updatedAt' },
        { condition: 'include', value: 'client' },
        { condition: 'equalTo', field: 'isActive', value: true }
      );
    }
    return this.getQueryCount(this.parseService, type, condition);
  }

  getQueryCount(parseService, type, condition) {
    return this.queryInterface.getQueryCount(parseService, type, condition);
  }

  /*
  ** ==========================================================
  ** Go to project details
  ** ==========================================================
  */
  updateProjectInformation(events) {
    this.router.navigate(['add-ons', { id: this.objectId, events }]);
  }

  toggleFilter() {
    this.showFilter = !this.showFilter;
  }

  toogleView(val) {
    this.gridView = val;
  }

  /*
 ** ==========================================================
 ** Go to sprint
 ** ==========================================================
 */
  async goToBacklogs(projectId, projectName) {
    let result = [];
    let queryInstance = this.parseService.instance.Object.extend('Sprint');
    let query = new this.parseService.instance.Query(queryInstance);
    query.include('project');
    query.equalTo('project', {
      __type: 'Pointer',
      className: 'Project',
      objectId: projectId
    });
    await query.find().then(results => {
      result = results;
      if (result.length > 0) {
        this.router.navigate(['/scrumboard/board/analytics/' + projectId + '/' + projectName]);
      }
      else {
        this.toastr.warning('Please create backlog board');
      }
    });
  }

}
